/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventupdated1Inputs */

const en_eventupdated1 = /** @type {(inputs: Eventupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event updated!`)
};

const de_eventupdated1 = /** @type {(inputs: Eventupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event aktualisiert!`)
};

/**
* | output |
* | --- |
* | "Event updated!" |
*
* @param {Eventupdated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventupdated1 = /** @type {((inputs?: Eventupdated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventupdated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventupdated1(inputs)
	return de_eventupdated1(inputs)
});
export { eventupdated1 as "eventUpdated" }